Array.prototype.groupBy = function (criteria) {
  return this.reduce(function (obj, item) {

    // Check if the criteria is a function to run on the item or a property of it
    var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

    // If the key doesn't exist yet, create it
    if (!obj.hasOwnProperty(key)) {
      obj[key] = [];
    }

    // Push the value to the object
    obj[key].push(item);

    // Return the object to the next item in the loop
    return obj;

  }, {});
};

String.prototype.replaceDiacritics = function() {
  var res = this.replace();

  var diacritics =[
    /[\300-\306]/g, /[\340-\346]/g, // A, a
    /[\310-\313]/g, /[\350-\353]/g, // E, e
    /[\314-\317]/g, /[\354-\357]/g, // I, i
    /[\322-\330]/g, /[\362-\370]/g, // O, o
    /[\331-\334]/g, /[\371-\374]/g,  // U, u
    /[\321]/g, /[\361]/g, // N, n
    /[\307]/g, /[\347]/g, // C, c
  ];

  var chars = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

  for (var i = 0; i < diacritics.length; i++)
  {
    res = res.replace(diacritics[i],chars[i]);
  }

  return res;
}

String.prototype.capitalizeFirstLetters = function() {
  let res = this.replace();

  if (res.trim() == "") return res;

  try {
    let out = res
      .trim()
      .toLowerCase()
      .split(" ")
      .map(d => d[0].toUpperCase() + d.slice(1))
        .join(" ");
    if (out.includes("-")) {
      out = out
        .split("-")
        .map(d => d != "" ? d[0].toUpperCase() + d.slice(1) : d)
        .join("-");
    }
    if (out.includes("(")) {
      out = out
        .split("(")
        .map(d => d != "" ? d[0].toUpperCase() + d.slice(1) : d)
        .join("(");
    }
    return out;
  }
  catch (e) {
    return res;
  }
}

const capitalizeFirstLetters = (str) => {
  let res = str.replace();

  if (res.trim() == "") return res;

  try {
    let out = res
        .trim()
        .toLowerCase()
        .split(" ")
        .map(d => d[0].toUpperCase() + d.slice(1))
        .join(" ");
    if (out.includes("-")) {
      out = out
        .split("-")
        .map(d => d != "" ? d[0].toUpperCase() + d.slice(1) : d)
        .join("-");
    }
    if (out.includes("(")) {
      out = out
        .split("(")
        .map(d => d != "" ? d[0].toUpperCase() + d.slice(1) : d)
        .join("(");
    }
    return out;
  }
  catch (e) {
    return res;
  }
}

const pnum = (n) => {
  return (+n).toLocaleString("fr-ca");
};

const bnum = (n) => {
  if (n >= 1000000) {
    return "" +  (n / 1000000).toFixed(1).replace(/\./, ",") + " M";
  } else if (n>= 1000) {
    return "" + (n / 1000).toFixed(0).replace(/\./, ",") + " K";
  } else {
    return n;
  }
};

const pcur = (n) => {
  return pnum(n) + " $";
};

const bcur = (n) => {
  return bnum(n) + "$";
};

const ppct = (n, signed=false) => {
  let pct = +n;
  if (pct>0 && signed) {
    return "+" + pct.toLocaleString("fr-ca", { minimumSignificantDigits:3,maximumSignificantDigits:3 }) + "%";
  }
  return pct.toLocaleString("fr-ca", { minimumSignificantDigits:3,maximumSignificantDigits:3 }) + "%";
};

const pdate_yyyy_mm_dd = (date) => {
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

const to_slug = (str) => {
  return str
    .toLowerCase()
    .replaceDiacritics()
    .replace(/ /ig,"-")
    .replace(/,/ig,"")
    .replace(/'/ig,"-")
    .replace(/\./ig,"")
    .replace(/\(/ig,"")
    .replace(/\)/ig,"");
};

const viewport_size = () => {
  let e = window;
  let a = "inner";
  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }
  return { width:e[ a+'Width' ], height:e[ a+'Height' ] };
};

// const is_mobile = (sel) => {
//   return viewport_size().width < 768;
// };

// const is_tablet = (sel) => {
//   let w = viewport_size().width;
//   return  w >= 768 && w < 1065;
// };

const is_iphone = () => {
  const u = navigator.userAgent;
  return u.match(/iPhone/i);
};

const is_android = () => {
  const u = navigator.userAgent;
  return u.match(/Android/i);
};

const is_ipad = () => {
  const u = navigator.userAgent;
  return u.match(/iPad/i);
};

const is_mobile = () => {
  const u = navigator.userAgent;
  return u.match(/Android/i) || u.match(/iPhone/i);
};

const is_desktop = (sel) => {
  return ! is_mobile() && viewport_size().width >= 1065;
};

const filter = (data, k, vals) => {
  return data.filter(d => vals.indexOf(d[k])!=-1);
};

const average = (vals) => {
  const n = vals.length;
  if (n == 0) return undefined;
  const sum = vals.reduce((acc,val) => acc + val);
  return sum / n;
};

const median = (vals) => {
  const n = vals.length;
  if (n == 0) return undefined;
  const vs = [...vals];
  vs.sort((a, b) => a - b);
  if (n % 2 == 1) {
    const i = (n + 1) / 2 - 1;
    return vs[i];
  }
  else {
    const i = n / 2 - 1;
    const j = i + 1;
    return ((vs[i] + vs[j]) / 2);
  }
};

const rnd = (max) => {
  return Math.floor(Math.random() * max);
};

const rel = (els) => {
  return els[rnd(els.length)];
};

const when_do = (predicate_s, action_s, interval_ms, log=false) => {
  var id = setInterval(() => {
    if (log) console.log(`when_do (#${id}) ...`);
    let res;
    if (Array.isArray(predicate_s)) {
      res = predicate_s.reduce((acc, f) => acc && f(), true);
    } else {
      res = predicate_s();
    }
    if (res) {
      if (Array.isArray(action_s)) {
        action_s.forEach(a => a());
      } else {
        action_s();
      }
      clearInterval(id);
    }
  }, interval_ms);
};

export {
  capitalizeFirstLetters,
  pnum, pcur, bnum, bcur, ppct, pdate_yyyy_mm_dd,
  to_slug,
  viewport_size, is_mobile, is_iphone, is_ipad, is_android, is_desktop,
  filter,
  average, median,
  rnd, rel,
  when_do
}
